// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Fkx5","errorLogs":"EditorFooter_errorLogs__2m2GK"};